<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';

    import SourceSet from './SourceSet.vue';

    import constants from './../../constants.js';

    export default {
        mixins: [mixin],
        components: { SourceSet },
        data() {
            return {
                constants: constants,
            }
        },
        computed: {
            listImage() {
                return this.item.image && this.item.image.length ? this.item.image.filter(set => set.alias === 'previewImageList_') : null;
            }
        },
        methods: {
            getNumber(string) {
                return string.match(/\d+/g).map(Number)[0];
            }
        },
        props: {
            item: Object
        }
    }
</script>

<template>
    <a :href="item.detailUrl" class="list-item-link" :title="item.title"></a>
    <div class="list-item-block is-flex has-mask">
        <div :class="['list-item-image-wrapper', 'is-relative', listImage && listImage.length ? 'has-image' : '']">
            <span :class="['list-item-tag', listImage && listImage.length ? '' : 'is-hidden-desktop'] " v-if="item.productionType">{{ item.productionType }}</span>
            <template v-if="listImage && listImage.length">
                <source-set :imageSets="listImage" image-class="list-item-image has-mask"/>
            </template>
            <picture class="list-item-image list-item-image--fallback has-mask" v-else>
                <img src="/svg/one-planet.svg" alt="One Planet" width="388" height="185">
            </picture>
        </div>
        <div class="list-item-content is-flex-grow-1">
            <div class="list-item-info is-flex mb-1 is-align-items-center" v-if="(item.productionType && (!listImage || !listImage.length)) || item.start || item.minimumAge && getNumber(item.minimumAge.name)">
                <span class="list-item-tag is-hidden-touch has-border" v-if="item.productionType && (!listImage || !listImage.length)">{{ item.productionType }}</span>
                <time class="list-item-date has-text-weight-semibold" datetime="item.start" v-if="item.start && item.agendaItemType.id !== constants.keys.exhibitionId && item.agendaItemType.id !== constants.keys.activityId">
                    <span class="date">{{ toExtendedDateStr(item.start) }}</span> | <span class="time">{{ toTimeStr(item.start) }}</span>
                    <template v-if="item.end"> - <span class="time">{{ toTimeStr(item.end) }}</span></template>
                </time>
                <span class="list-item-tag has-border" v-if="item.minimumAge && getNumber(item.minimumAge.name)">{{ getNumber(item.minimumAge.name) }} +</span>
            </div>
            <h2 class="title is-4 list-item-title" v-if="item.title">
                <span>{{ item.title }}</span>
                <span class="list-item-icon"><img src="/svg/arrow-right.svg" alt="arrow right" width="18" height="12" loading="lazy"></span>
            </h2>
            <div class="list-item-subtitle is-size-7 mb-2" v-if="item.shortDescription" v-html="item.shortDescription"></div>
            <a :href="item.availability.orderUrl" class="button is-secondary is-rounded is-small" :title="item.availability.buttonText" v-if="item.availability && item.availability.orderUrl">
                <span>{{ item.availability.buttonText }}</span>
                <span class="icon"><img src="/svg/chevron-right.svg" width="9" height="15" alt="chevron right" loading="lazy"></span>
            </a>
        </div>
    </div>
</template>
